import React, {createContext} from 'react'

import useUniqueId from '../../hooks/use-unique-id'
import cn from '../../libs/class-names'

export const FieldLabelContext = createContext<{
  id?: Props['id']
}>({})

export interface Props {
  classNames?: string[]
  label: string
  children: React.ReactNode
  id?: string
  addendum?: string
}

const FieldLabel = ({classNames, label, children, id, addendum}: Props) => {
  const fieldId = useUniqueId(id)
  const contextValue = React.useMemo(() => ({id: fieldId}), [fieldId])

  return (
    <div className={cn('FieldLabel', {}, classNames)}>
      <div className="FieldLabel__label">
        <label htmlFor={fieldId}>
          {label}
          {!!addendum && <span className="FieldLabel__addendum">{addendum}</span>}
        </label>
      </div>
      <FieldLabelContext.Provider value={contextValue}>{children}</FieldLabelContext.Provider>
    </div>
  )
}

export default FieldLabel
